module.exports = __webpack_public_path__ + "static/media/informacion.40df1c91.svg";